<template>
  <div style="width: 0px; height: 0px;">
    <div v-if="isOpen" :class="['cookie-sidebar-backdrop']"></div>
      <div class="cookie-content cookie-sidebar" :class="{'cookie-sidebar-open': isOpen}">
        <div class="cookie-header">
          <div class="modal-header-right">
            <slot name="header-right-block"></slot>
          </div>
        </div>
        <h3 class="cookie-title">{{ $t(content.header || header) }}</h3>
        <div :class="['cookie-body']">
          <div class="text" v-html="$t(content.message || message)"></div>
          <div class="options-list">
            <template v-for="service of services">
              <div :key="service.key" class="option-item">
                <div class="checkbox-container checkbox">
                  <input
                    style="display: none;"
                    type="checkbox"
                    :id="service.key"
                    :name="service.key"
                    v-model="service.enabled"
                    readonly :disabled="service.required ? 'disabled' : undefined"
                  >
                  <label class="checkbox-label" :for="service.key"></label>
                </div>
                <div style="display: inline-block; width: calc(100% - 40px); position: relative; top: 12px;">
                  <span class="service-name text-uppercase">{{$t(service.label)}}</span>
                  <span class="clickable" @click="service.showDetails = !service.showDetails">
                    <span class="service-count">{{service.items.length}} {{$t('CookieConsent.services')}}</span>
                    <span class="icon">
                      <i :class="['fal', `fa-long-arrow-${service.showDetails ? 'up' : 'down'}`]"></i>
                    </span>
                  </span>

                  <div v-if="service.showDetails" class="service-details" >
                    <div class="service-item" v-for="(item, index) of service.items" :key="index">
                      <span class="service-item-name">{{$t(item.label)}}</span>
                      <span class="service-item-description">{{$t(item.description)}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
        </div>
      </div>
      <div class="modal-cookie-footer">
        <button type="button" class="confirm-btn color-success" v-on:click="accept">{{ $t(content.deny || 'CookieConsent.acceptSelection') }}</button>
        <button type="submit" class="accept-all-btn btn btn-success" @click="acceptAll">
            {{ $t(content.allow || 'CookieConsent.acceptAll') }}
            <span class="icon">
              <i class="far fa-arrow-right"></i>
            </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>

const getCookie = name => {
  const value = ' ' + document.cookie
  const parts = value.split(' ' + name + '=')
  return parts.length < 2
    ? undefined
    : parts
        .pop()
        .split(';')
        .shift()
}

const setCookie = function ( name, value, expiryDays, domain, path, secure ) {
  const exdate = new Date()
  exdate.setHours(exdate.getHours() + ((typeof expiryDays !== "number"  ? 365 : expiryDays ) * 24))
  document.cookie = name + '=' + value +
                    ';expires=' + exdate.toUTCString() +
                    ';path=' + (path || '/') +
                    ( domain ? ';domain=' + domain : '' ) +
                    ( secure ? ';secure' : '' )
}


export default {
  name: 'CookieNotification',
  data() {
    return {
      services: [{
        key: 'required',
        required: true,
        label: 'CookieConsent.required',
        enabled: true,
        items: [{
          label: 'Cookie Consent',
          description: 'CookieConsent.servicesDescription.cookieconsent'
        },{
          label: 'Laravel Session',
          description: 'CookieConsent.servicesDescription.laravel'
        },{
          label: 'XSRF-TOKEN',
          description: 'CookieConsent.servicesDescription.XSRFTOKEN'
        },{
          label: '__cfduid',
          description: 'CookieConsent.servicesDescription.cfduid'
        },{
          label: 'Sentry',
          description: 'CookieConsent.servicesDescription.sentry'
        }],
        showDetails: false,
      }, {
        key: 'analytics',
        label: 'CookieConsent.analytics',
        items: [{
          label: 'Google Analytics',
          description: 'CookieConsent.servicesDescription.googleAnalytics'
        },{
          label: 'YouTube',
          description: 'CookieConsent.servicesDescription.youtube'
        }],
        showDetails: false,
        enabled: false,
      }],
      isOpen: false,
      header: 'CookieConsent.header',
      message: 'CookieConsent.message'
    }
  },
  mounted() {

    if (this.$root.cookieconsentConfig !== false && !this.$root.isPrintMode && !this.$root.isEmbeddedMode) {

      setTimeout(() => {
        const status = getCookie('cookieconsent_status')
        if (!status) {
          this.isOpen = true;
        }

        const enabledServices = (status || 'deny').split(',');
        this.services.forEach(_ => {
          if (!_.required) {
            _.enabled = enabledServices.includes(_.key) || enabledServices[0] === 'allow'
          }
        });
        this.services = [...this.services];

        this.enableDisableServices();

        setTimeout(() => {
          if (window.ga) {
            window['ga']('create', this.gaTracker, 'auto');
            window['ga']('send', 'pageview');
          }
        }, 1);
      }, 2000)
    }
  },
  computed: {
    cookieconsentConfig() {
      return this.$root.cookieconsentConfig || {};
    },
    content() {
      return this.cookieconsentConfig.content || {};
    },
    gaTracker() {
      return this.$root.gaTracker;
    },
    domain() {
      return window.location.host;
    },
    allEnabled() {
      return this.services.every(_ => _.enabled === true);
    },
    optionalDisabled() {
      return this.services.every(_ => _.required || !_.enabled)
    }
  },
  methods: {
    acceptAll() {
      this.services = this.services.map(_ => ({..._, enabled: true}));
      this.accept();
    },
    accept () {

      let value = 'deny';
      if (this.allEnabled) {
        value = 'allow';
      } else if (!this.optionalDisabled) {
        value = this.services.map(_ => _.key).join(',');
      }
      setCookie('cookieconsent_status', value, undefined, this.domain);

      this.enableDisableServices();
      this.isOpen = false;
    },
    setCookies() {
      let value = 'deny';
      if (this.allEnabled) {
        value = 'allow';
      } else if (!this.optionalDisabled) {
        value = this.services.map(_ => _.key).join(',');
      }
      setCookie('cookieconsent_status', value, undefined, this.domain);
    },
    enableDisableServices() {
      const analyticsEnabled = this.services.some(_ => _.key === 'analytics' && _.enabled);
      if (!analyticsEnabled) {
        console.log('Disabled ga');
        window[`ga-disable-${this.gaTracker}`] = true;
      } else {
        console.log('Enable ga');
        delete window[`ga-disable-${this.gaTracker}`];
      }
    }
  }
}
</script>

<style lang="scss" scoped>

// @import '../sass/config.sass';

$grey-lighter: #e7edee;
$black-lighter: #666;
$z-modal-cookie: 1000;

.text, .options-list {
  margin: 10px 0px;
}

.text {
  font-size: 14px;
}

.options-list {
  .option-item {
    label {
      margin-left: 10px;
    }
    input {
      vertical-align: top;
    }
    .service-details, .service-count, .icon {
      font-size: 13px;
      font-weight: 100;
      .service-item {
        padding: 2px;
        .service-item-name {
          font-size: 14px;
          font-weight: bold;
          padding-right: 5px;
        }
      }
    }
    .service-name {
      margin-right: 10px;
    }
    .service-count, .icon {
      margin-left: 3px;
    }
  }
}

.text-uppercase {
  text-transform: uppercase;
}

.clickable {
  cursor: pointer;
}

.cookie-title {
  display: inline-block;
}

.modal-header-right {
  display: inline-block;
  width: 160px;
  top: -15px;
}

.cookie-sidebar {
  height: 100vh;
  min-width: 400px;
  width: 50vw;
  max-width: 600px;
  position: absolute;
  top: 0;
  right: -617px;
  z-index: $z-modal-cookie !important;
  transition: all .3s ease;
}

.cookie-sidebar-open {
  right: -0px;
}

.cookie-sidebar-backdrop {
  z-index: $z-modal-cookie - 1 !important;
  display: block;
  height: 100vh;
  width: 100vw;
  top: 0px;
  left: 0px;
  position: absolute;
  background: black;
  opacity: 0.3;
}

.cookie-content {
  padding: 20px;
  background-color: #1B2230;
  color: #FAFAFB;
  border: 3px;
  font-size: 16px;
  box-shadow: 0 1px -1px $black-lighter;
  overflow: hidden !important;
  overflow-y: auto;
  .cookie-header {
  }
  .modal-cookie-body {
    max-height: calc(90vh - 150px);
    &.no-padding {
      padding: 0;
    }
  }
  .modal-cookie-footer {
    button {
      padding: 10px;
      margin: 10px 0px;
      border-radius: 20px;
      box-shadow: none;
      border: none;
      display: inline-flex;
    }

    .confirm-btn {
      background-color: transparent;
      // color: #FF6433;
      width: 80px;
      font-size: 13px;

      &:hover {
        color: white;
      }
      margin-right: 10px;
    }
    .accept-all-btn {
      // background-color:$primary-color;
      color: white;
      font-size: 18px;
      padding: 13px;
      position: relative;
      margin-left: 50px;
      top: 7px;
      // &:hover {
      //   background-color: white;
      //   color: #FF6433;
      // }

      .icon {
        margin-right: 5px;
        margin-left: 8px;
      }
    }
  }
}

$grey-darker: #c8d1d3;
$green: #00a99d;
$green-darker: #095c57;
$white: white;

.checkbox-container {
  vertical-align: top;
  display: inline-block;
  position: relative;
  margin-top: 10px !important;
  margin-bottom: 15px !important;

  input:checked + label::after {
    content: '\2713';
    color: $white;
    background: transparent;
    border: none;
    box-shadow: none;
  }

  &.checkbox-inline {
    padding-left: 0;
  }

  &+.checkbox-inline {
    margin-top: 10px;
  }

  label {
    padding-left: 30px;
    &:before, &:after {
      display: block;
      position: absolute;
      left: 0;
      top: 50%;
      width: 25px;
      height: 25px;
      transform: translate(0,-50%);
      border-radius: 2px;
    }
    &:before {
      content: '';
      border: 1px solid $grey-darker;
      border-bottom: 2px solid $grey-darker;
    }
    &:after {
      content: '';
      font-family: FontAwesome;
      text-align: center;
      border-radius: 2px;
      font-size: 0.95em;
      border: 1px solid transparent;
    }
  }
}

</style>
